var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 238,
    viewBox: "0 0 326 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.675 177.676C296.843 198.094 281.601 215.22 261.67 222.543C241.738 229.867 219.781 229.296 198.72 226.593C170.317 222.95 142.393 215.598 115.88 204.782C104.253 200.336 93.2041 195.42 82.302 190.194C70.763 184.662 59.3114 178.734 49.2326 170.848C39.1538 162.962 30.4393 152.962 25.7354 141.062C19.015 124.061 21.3464 103.771 31.4167 89.3136C36.4544 80.7686 44.6126 74.5309 53.0516 69.3169C61.4905 64.1029 70.4481 59.6592 78.2656 53.5534C89.7258 44.6044 98.3343 32.3961 109.899 23.5823C125.503 11.6925 146.226 6.77461 164.326 10.056C179.803 13.661 194.612 20.5885 206.688 30.9206C230.661 51.4325 235.74 74.1766 265.879 104.317C276.127 114.565 286.865 124.475 294.804 136.601C297.492 140.706 299.936 144.995 301.682 149.581C305.587 159.841 304.327 171.892 302.675 177.676Z",
    fill: "#E4F3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.83 16.2974L157.651 125.118C157.651 125.118 152.003 9.02069 151.892 9.06862C161.931 8.91114 171.998 11.1313 181.04 15.4963C181.618 15.777 182.721 16.1022 182.83 16.2974Z",
    fill: "url(#paint0_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.257 57.2325L159.018 124.1C159.018 124.1 210.616 34.5809 210.761 34.8103C217.766 41.6179 224 49.2164 229.257 57.2325Z",
    fill: "url(#paint1_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.706 107.249L159.018 125.114C159.018 125.114 246.931 82.7268 246.835 82.9066C253.534 91.5407 260.859 99.6903 268.706 107.249Z",
    fill: "url(#paint2_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.378 144.682L161.081 126.833C161.081 126.833 299.135 186.894 299.19 186.724C302.134 180.052 303.984 172.851 304.143 165.559C304.304 158.266 302.73 150.884 299.378 144.682Z",
    fill: "url(#paint3_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3938 55.5229L156.277 124.766C156.277 124.766 48.0041 72.4436 47.8774 72.4145C53.7042 68.9054 59.531 65.3946 65.3561 61.8838C68.7556 59.8366 72.1603 57.7842 75.3938 55.5229Z",
    fill: "url(#paint4_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5868 134.94L156.624 126.477C156.624 126.477 26.009 98.9037 26.0946 99.0868C21.3034 110.318 20.4577 123.188 23.5868 134.94Z",
    fill: "url(#paint5_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7156 186.009L156.271 127.853C156.271 127.853 44.4583 166.97 44.4857 166.963C53.3594 174.583 63.255 181.014 73.7156 186.009Z",
    fill: "url(#paint6_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.141 228.401L162.45 129.221C162.45 129.221 265.314 220.959 265.268 220.883C251.031 226.633 235.524 229.211 220.141 228.401Z",
    fill: "url(#paint7_linear_3936_130306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16 223.844L158.685 127.853C158.685 127.853 148.458 216.128 148.679 216.159C159.407 219.361 170.326 221.927 181.16 223.844Z",
    fill: "white",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.879 16.6384L157.303 124.444C157.303 124.444 96.6476 35.5944 96.6681 35.7793C100.609 31.5392 104.005 28.4153 107.955 25.0414C111.906 21.6676 116.24 18.6651 120.879 16.6384Z",
    fill: "url(#paint8_linear_3936_130306)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.348 100.643L234.849 113.589L250.645 125.151L302.348 100.643Z",
    fill: "#EBC463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.256 128.822L302.585 100.732L278.158 141.85L256.256 128.822Z",
    fill: "#EBC463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.653 125.157L249.073 147.498L256.272 128.821L302.355 100.848L302.475 100.728L250.653 125.157Z",
    fill: "#DBA725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.122 134.679L249.102 147.712L256.25 128.863L266.122 134.679Z",
    fill: "#BC8909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.332 128.312V211.144C228.335 211.971 228.174 212.791 227.858 213.556C227.543 214.322 227.08 215.017 226.495 215.602C225.91 216.187 225.216 216.651 224.451 216.967C223.687 217.282 222.867 217.443 222.04 217.441H100.08C98.4112 217.441 96.8109 216.777 95.631 215.596C94.4511 214.415 93.7882 212.814 93.7882 211.144V128.312L112.179 142.35V190.315H208.973V142.844L228.332 128.312Z",
    fill: "#48A8EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.34 128.313L166.063 175.183C164.49 176.375 162.572 177.02 160.599 177.02C158.626 177.02 156.707 176.375 155.135 175.183L93.7964 128.313L156.422 80.9683C157.763 79.9621 159.393 79.4182 161.068 79.4182C162.744 79.4182 164.374 79.9621 165.714 80.9683L228.34 128.313Z",
    fill: "#0E336F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.967 142.891V190.361H112.173V142.367L155.091 175.142C156.673 176.338 158.601 176.986 160.584 176.986C162.567 176.986 164.496 176.338 166.077 175.142L208.967 142.891Z",
    fill: "#48A8EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.967 106.028V142.842L166.077 175.122C164.496 176.319 162.567 176.966 160.584 176.966C158.601 176.966 156.673 176.319 155.091 175.122L112.173 142.367V90.2944C112.171 89.5625 112.314 88.8376 112.594 88.1612C112.873 87.4848 113.283 86.8702 113.8 86.3526C114.317 85.8351 114.931 85.4248 115.607 85.1453C116.283 84.8658 117.007 84.7226 117.738 84.7239H186.307V99.2557C186.307 101.054 187.021 102.779 188.292 104.051C189.562 105.323 191.286 106.037 193.083 106.037L208.967 106.028Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.971 106.028H191.548C190.154 106.028 188.817 105.473 187.832 104.487C186.846 103.5 186.292 102.162 186.292 100.767V84.7239L208.971 106.028Z",
    fill: "#9DCAEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.332 211.135C228.335 211.962 228.174 212.782 227.858 213.548C227.543 214.313 227.08 215.008 226.495 215.593C225.91 216.178 225.216 216.642 224.451 216.958C223.687 217.273 222.867 217.434 222.04 217.432H100.08C98.4112 217.432 96.8109 216.768 95.631 215.588C94.4511 214.407 93.7882 212.805 93.7882 211.135L148.187 170.31L154.885 175.425C156.533 176.674 158.543 177.349 160.61 177.349C162.677 177.349 164.687 176.674 166.335 175.425L173.556 169.99L228.332 211.135Z",
    fill: "#2662A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.558 129.827L157.598 145.867L184.435 119.031",
    stroke: "#48A8EE",
    strokeWidth: 8.5986
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3936_130306",
    x1: 167.361,
    y1: 9.06079,
    x2: 167.361,
    y2: 125.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3936_130306",
    x1: 173.396,
    y1: 108.009,
    x2: 247.687,
    y2: 23.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3936_130306",
    x1: 180.928,
    y1: 118.952,
    x2: 279.867,
    y2: 86.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3936_130306",
    x1: 183.334,
    y1: 135.734,
    x2: 316.509,
    y2: 172.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3936_130306",
    x1: 132.312,
    y1: 110.387,
    x2: 32.0037,
    y2: 51.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3936_130306",
    x1: 136.425,
    y1: 125.108,
    x2: 2.56588,
    y2: 117.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3936_130306",
    x1: 116.558,
    y1: 147.367,
    x2: 36.106,
    y2: 186.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3936_130306",
    x1: 175.802,
    y1: 151.817,
    x2: 258.309,
    y2: 243.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3936_130306",
    x1: 150.456,
    y1: 109.38,
    x2: 93.9681,
    y2: 16.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.b4738e2e90bb861e62afda24cbef254b.svg";
export { ForwardRef as ReactComponent };